// extracted by mini-css-extract-plugin
module.exports = {"container":"Button-module--container--3gPAp","outline":"Button-module--outline--2c8F2","delete":"Button-module--delete--3yC_G"};